import apiClient from '../../shared/auth/services'

// Helper function to make API calls
const apiCall = async (endpoint, data = {}) => {
  try {
    const response = await apiClient.post(endpoint, data)
    return response.data
  } catch (error) {
    console.error(`API call failed for ${endpoint}:`, error)
    throw error
  }
}

// Helper function for file downloads
const downloadFile = async (endpoint, data = {}) => {
  try {
    const response = await apiClient.post(endpoint, data, {
      responseType: 'blob'
    })
    return response.data
  } catch (error) {
    console.error(`Download failed for ${endpoint}:`, error)
    throw error
  }
}

export const satsueiDataKensakuService = {
  // Get satsuei memo categories
  getSatsueiMemoCategory: (data = {}) => apiCall('/getSatsueiMemoCategory', data),

  // Get satsuei memo columns
  getSatsueiMemoColumn: (data = {}) => apiCall('/getSatsueiMemoColumn', data),

  // Get kyoten list
  getKyotenList: () => apiCall('/getKyotenList'),

  // Get PIX user list
  getPixUserList: () => apiCall('/getPixUserList'),

  // Get object list (search results)
  getObjectList: (data = {}) => apiCall('/getObjectList', data),

  // Download object list
  getObjectListDownload: (data = {}) => downloadFile('/getObjectListDownload', data),

  // Get image - returns blob data for proper cleanup
  // imageType: optional 'satsueiImage' for full image (e.g. carousel); default 'thumb_comp'
  getImage: async (objectId, objectImageId, objectImageEditId, filenameExtension, isUploaded, imageType) => {
    try {
      const type = imageType === 'satsueiImage' ? 'satsueiImage' : 'thumb_comp'
      const params = {
        objectId,
        objectImageId,
        objectImageEditId,
        filenameExtension,
        isUploaded: isUploaded !== null && isUploaded !== undefined ? isUploaded : false,
        type,
      }
      if (type !== 'satsueiImage') {
        params.width = 148
        params.height = 148
      }
      const response = await apiClient.get('/getImage', {
        params,
        responseType: 'blob',
        headers: { Accept: 'image/jpeg' }
      })
      return response.data // Return blob data instead of URL
    } catch (error) {
      console.error('Failed to get image blob:', error)
      return null
    }
  },

  // Legacy method that returns URL (deprecated - use getImage with useBlobUrl hook instead)
  getImageUrl: async (objectId, objectImageId, objectImageEditId, filenameExtension, isUploaded) => {
    try {
      const response = await apiClient.get('/getImage', {
        params: {
          objectId,
          objectImageId,
          objectImageEditId,
          filenameExtension,
          isUploaded: isUploaded !== null && isUploaded !== undefined ? isUploaded : false,
          type: 'thumb_comp',
          width: 148,
          height: 148
        },
        responseType: 'blob',
        headers: { Accept: 'image/jpeg' }
      })
      return URL.createObjectURL(response.data)
    } catch (error) {
      console.error('Failed to get image URL:', error)
      return null
    }
  }
}
